import React from "react";
const PaperAirplaneIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.9543 1.11086C16.1783 0.451968 15.539 -0.174904 14.867 0.0446968L0.587836 4.71128C-0.214033 4.97331 -0.189176 6.09364 0.623489 6.32124L7.56824 8.2667L9.55245 15.0755C9.7847 15.8723 10.9273 15.8967 11.1946 15.1104L15.9543 1.11086ZM14.8349 1.73835L10.3791 14.844L8.39869 8.04843L14.8349 1.73835ZM14.227 1.14235L7.79087 7.45242L0.859722 5.51088L14.227 1.14235Z"
      fill="#767C8F"
    />
  </svg>
);
export default PaperAirplaneIcon;
